import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

const AvatarWrapper = styled.div`
  height: 38px;
  ${props =>
    props.hasImage
      ? css`
          display: grid;
          grid-template-columns: 32px 1fr;
          grid-gap: 10px;
        `
      : css`
          display: flex;
          flex-direction: row;
          align-items: center;
        `}
`

const Portrait = styled.div`
  align-self: center;
  width: 32px;
  height: 32px;

  .gatsby-image-wrapper {
    width: 32px;
    height: 32px;
  }

  img {
    display: block;
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50%;
  }
`

const Name = styled.div`
  align-self: center;
  line-height: 0;
  font-weight: 500;
`

const Avatar = ({ image, name }) => {
  return (
    <AvatarWrapper className="avatar" hasImage={!!image}>
      {image && <Portrait>{image}</Portrait>}
      {name && <Name>{name}</Name>}
    </AvatarWrapper>
  )
}

Avatar.propTypes = {
  image: PropTypes.element,
  name: PropTypes.string.isRequired,
}

export { Avatar }
